// src/api/api.js
import axios from "axios";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// === REQUEST INTERCEPTOR ===
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// === RESPONSE INTERCEPTOR ===
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("⛔ Session expired — redirecting to login");

      toast.error("Session expired. Please log in again.");

      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("currentTab");
        window.location.href = "/login";
      }, 1200);
    }

    return Promise.reject(error);
  }
);

export default api;
